import { createLucideIcon } from 'lucide-react';

export const CircleRadio = createLucideIcon('CircleRadio', [
  [
    'path',
    {
      key: 'path-1',
      d: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12a11 11 0 1 1 22 0 11 11 0 0 1-22 0',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
  [
    'circle',
    {
      key: 'circle-1',
      cx: '12',
      cy: '12',
      r: '6.5',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
]);
